module.exports = __webpack_public_path__ + "media/2.accf448b.mp4";